class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').classList.add('loading');
    if (document.querySelector('.facets__form-vertical')) {
      document.querySelector('.facets__form-vertical').classList.add('loading');
    }

    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { responseText, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const response = FacetFiltersForm.filterData.find(filterDataUrl).responseText;
    const html = new DOMParser().parseFromString(response, 'text/html');

    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('ProductGridContainer');
    const newContainer = html.getElementById('ProductGridContainer');
    
    if (!container || !newContainer) return;
    
    container.innerHTML = newContainer.innerHTML;

    container.classList.remove('loading');
    if (document.querySelector('.facets__form-vertical')) {
      document.querySelector('.facets__form-vertical').classList.remove('loading');
    }

    // Reordenar produtos após aplicar filtros
    FacetFiltersForm.reorderProductsInGrid();

    if (document.querySelector('grid-column-switch[grid="product-grid"]')) {
      document.querySelector('grid-column-switch[grid="product-grid"]').updateGrid();
    }
  }

  /**
   * Reordena por disponibilidade só quando a ordenação é "Em destaque" (manual).
   * Se o usuário escolheu preço, mais vendidos, etc., mantém a ordem que o servidor enviou.
   */
  static reorderProductsInGrid() {
    const productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    const params = new URLSearchParams(window.location.search);
    const sortBy = params.get('sort_by') || '';
    const useAvailabilitySort = !sortBy || sortBy === 'manual' || sortBy === 'manual-ascending' || sortBy === 'manual-descending';
    if (!useAvailabilitySort) return;

    const allItems = Array.from(productGrid.children);
    if (allItems.length === 0) return;

    if (typeof sortProductsByAvailability === 'function') {
      const sortedItems = sortProductsByAvailability(allItems);
      allItems.forEach(item => item.remove());
      sortedItems.forEach((item, index) => {
        item.style.animationDelay = (index % 10).toString() + '00ms';
        productGrid.appendChild(item);
      });
    } else {
      setTimeout(() => FacetFiltersForm.reorderProductsInGrid(), 100);
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = html;

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter',
      '#FacetFiltersButton .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };

    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));

    facetsToRender.forEach((element) => {
      const currentElement = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (currentElement) {
        currentElement.innerHTML = element.innerHTML;
        currentElement.setAttribute('data-available', element.dataset.available);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['#FacetFiltersForm .active-facets', '#FacetFiltersButton .active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });
  }

  static renderProductCount(html) {
    const countElement = html.getElementById('ProductCountDesktop');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    
    if (countElement && containerDesktop) {
      containerDesktop.innerHTML = countElement.innerHTML;
      containerDesktop.classList.remove('loading');
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];

    sortFilterForms.forEach((form) => {
      if (
        form.id === 'FacetSortForm' ||
        form.id === 'FacetFiltersForm' ||
        form.id === 'FacetFiltersButton' ||
        form.id === 'FacetCountForm'
      ) {
        const noJsElements = document.querySelectorAll('.no-js-list');
        noJsElements.forEach((el) => el.remove());
        forms.push(this.createSearchParams(form));
      }
    });
    this.onSubmitForm(forms.join('&'), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    const rangeInput = this.querySelectorAll('.filter-price-range-input .field__input');
    const hiddenInput = this.querySelectorAll('.filter-price-range-input .hidden');
    const priceInput = this.querySelectorAll('.filter-price-price-label .price-label-value');
    const range = this.querySelector('.price-slider .progress');
    let priceGap = 0;

    rangeInput.forEach((input) => {
      let minVal = parseInt(rangeInput[0].value);
      let maxVal = parseInt(rangeInput[1].value);

      if (maxVal - minVal < priceGap) {
        if (e.target.className === 'input-value-min') {
          rangeInput[0].value = maxVal - priceGap;
        } else {
          rangeInput[1].value = minVal + priceGap;
        }
      } else {
        priceInput[0].setAttribute('value', minVal);
        priceInput[1].setAttribute('value', maxVal);
        range.style.left = (minVal / rangeInput[0].max) * 100 + '%';
        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';
      }

      input.addEventListener('input', (e) => {
        let minVal = parseInt(rangeInput[0].value);
        let maxVal = parseInt(rangeInput[1].value);

        if (maxVal - minVal < priceGap) {
          if (e.target.className === 'input-value-min') {
            rangeInput[0].value = maxVal - priceGap;
          } else {
            rangeInput[1].value = minVal + priceGap;
          }
        } else {
          priceInput[0].setAttribute('value', minVal);
          priceInput[1].setAttribute('value', maxVal);

          range.style.left = (minVal / rangeInput[0].max) * 100 + '%';
          range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + '%';

          // Limpar filtro se os valores são iguais aos limites min/max padrão
          if (minVal == 0 && maxVal == rangeInput[1].max) {
            hiddenInput[0].value = '';
            hiddenInput[1].value = '';
          } else {
            hiddenInput[0].value = minVal;
            hiddenInput[1].value = maxVal;
          }
        }
      });
    });
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetFiltersToggler extends HTMLElement {
  constructor() {
    super();

    // Bind methods to this
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleEscKey = this.handleEscKey.bind(this);

    this.querySelector('[data-target]').addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById(e.currentTarget.dataset.target);

      if (!target) return;

      target.classList.toggle('active');

      // Add event listeners when panel opens
      if (target.classList.contains('active')) {
        document.addEventListener('click', this.handleClickOutside);
        document.addEventListener('keydown', this.handleEscKey);
      }
    });
  }

  handleClickOutside(event) {
    const target = document.getElementById(this.querySelector('[data-target]').dataset.target);
    if (!target) return;

    // Close if click is outside the target and the toggler
    if (!target.contains(event.target) && !this.contains(event.target)) {
      target.classList.remove('active');
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEscKey);
    }
  }

  handleEscKey(event) {
    if (event.key === 'Escape') {
      const target = document.getElementById(this.querySelector('[data-target]').dataset.target);
      if (!target) return;

      target.classList.remove('active');
      document.removeEventListener('click', this.handleClickOutside);
      document.removeEventListener('keydown', this.handleEscKey);
    }
  }
}

customElements.define('facet-filters-toggler', FacetFiltersToggler);
